import {
  Permission as Data,
  PermissionCollection as Collection,
} from '@/typings/api/Permission'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class PermissionsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'permissions/permissions';
}
